import { render, staticRenderFns } from "./classesList.vue?vue&type=template&id=7fa9f867&scoped=true&"
import script from "./classesList.vue?vue&type=script&lang=js&"
export * from "./classesList.vue?vue&type=script&lang=js&"
import style0 from "./classesList.vue?vue&type=style&index=0&id=7fa9f867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa9f867",
  null
  
)

export default component.exports